"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_input_connector_1 = __importDefault(require("components/form/snap-ui-input-connector"));
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
class FormSectionProfile extends React.Component {
    render() {
        const { disabled } = this.props;
        return (React.createElement("div", { id: "profile-information", className: "sui-border sui-p-4 sui-mb-2 sui-border-neutral-border sui-bg-neutral-background sui-rounded" },
            React.createElement("h3", { className: "sui-heading-md sui-font-normal sui-text-gray-40" }, "Login Information"),
            React.createElement("div", { id: "login-settings-form", className: "" },
                React.createElement(redux_form_1.Field, { id: "email", name: "email", label: "Email", required: true, className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "email", disabled: disabled }),
                React.createElement(redux_form_1.Field, { id: "currentPassword", name: "currentPassword", label: "Current password", required: true, className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "password", autocomplete: "current-password", disabled: disabled }),
                React.createElement(redux_form_1.Field, { id: "password", name: "password", label: "New password", className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "password", autocomplete: "new-password", disabled: disabled }),
                React.createElement(redux_form_1.Field, { id: "passwordConfirmation", name: "passwordConfirmation", label: "Confirm password", className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "password", autocomplete: "new-password", disabled: disabled }))));
    }
}
exports.default = FormSectionProfile;
